class IconUtils {
    static getUrlFromIconFileName(fileName) {
         return "/icons/" + fileName;
    }
}

export default IconUtils;
